/** Landing page pitch — keep in sync with greeting screen. */

export const LANDING_TAGLINE =
  "Play alone or with up to two other friends! Take on the role of a detective where your goal is to solve a murder. You're not up against a clock - relax, and use your brain. Have fun!";

export const REGISTER_DISPLAY_NAME_HINT =
  "Leave blank to use your username in game.";
